<script setup>
import { usePage } from '@inertiajs/vue3';

const page = usePage()

</script>
<template>
    <img :src="page.props.wawLogoUrl" class="max-h-full my-3 mx-4" alt="Wealth at work logo" />
</template>
